<template>
  <div id="Blog">
    <div class="banner">
      <img src="/static/images/blog/blog_bg.png" alt="">
      <div class="bannerText">
        <div class="title">{{$t("blog.bannerText")}}</div>
        <div class="titleSub">{{$t("blog.bannerDetail")}}</div>
      </div>
    </div>
    <div class="content">
        <div class="con">
          <div class="blogList" v-for="(item,index) in blogList" :key="index" :class="index==selectId?'active':''" @mouseover="blogItemShow(index)" @mouseleave="blogItemHidden(index)">
            <div class="left">
              <img :src="item.src" alt="">
            </div>
            <div class="right">
                <div class="title">{{item.title}}</div>
                <div class="detail">
                  <p>{{item.detail}}</p>
                </div>
                <div class="time">{{item.time}}</div>
            </div>
            <div class="Btn">
              <router-link :to="{path:'/BlogDetail'}">
                <div class="moreBtn">More</div>
              </router-link>
            </div>
          </div>
          <el-pagination
            background
            layout="prev, pager, next"
            :total="pages"
            :page-size=4
            @current-change='changePage'>
          </el-pagination>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selectId:null,
      blogList:[
        {
          title:'LAN Kitchen printer 80mm',
          src:'/static/images/blog/blog_a.png',
          detail:' We are happy to help you quickly install Ocha to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible.  We are happy to help you quickly install Ocha to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible. We are happy to help you quickly install Ocha to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible. We are happy to help you quickly install Ocha to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible. We are happy to help you quickly install Ocha to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible.',
          time:'06-19 /2019'
        },
        {
          title:'LAN Kitchen printer 80mm',
          src:'/static/images/blog/blog_b.png',
          detail:' We are happy to help you quickly install Ocha to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible.  We are happy to help you quickly install Ocha to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible. We are happy to help you quickly install Ocha to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible. We are happy to help you quickly install Ocha to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible. We are happy to help you quickly install Ocha to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible.',
          time:'06-19 /2019'
        },
        {
          title:'LAN Kitchen printer 80mm',
          src:'/static/images/blog/blog_c.png',
          detail:' We are happy to help you quickly install Ocha to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible.  We are happy to help you quickly install Ocha to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible. We are happy to help you quickly install Ocha to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible. We are happy to help you quickly install Ocha to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible. We are happy to help you quickly install Ocha to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible.',
          time:'06-19 /2019'
        },
        {
          title:'LAN Kitchen printer 80mm',
          src:'/static/images/blog/blog_d.png',
          detail:' We are happy to help you quickly install Ocha to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible.  We are happy to help you quickly install Ocha to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible. We are happy to help you quickly install Ocha to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible. We are happy to help you quickly install Ocha to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible. We are happy to help you quickly install Ocha to meet your business needs. Leave your business information and our friendly staff will contact you as soon as possible.',
          time:'06-19 /2019'
        },
      ],
      pages:11
    };
  },
  //定义这个sweiper对象
  computed: {},
  created:function () {
    window.scroll(0, 0);
    this.$emit('menuHiddens');
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    if (this.$getCookie("langs") == "en") {
      this.lang_en = true;
    } else {
      this.lang_en = false;
    }
    this.show=true
  },
  methods: {
    blogItemShow(id){
      this.selectId = id
    },
    blogItemHidden(id){
      this.selectId = null
    },
    changePage(el){
      console.log(el)
    }
  }
};
</script>
<style lang="less" type="text/less">
  .el-pagination {
    text-align: center;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: #333;
    color: #FFF;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover{
    color: #333;
  }
  .el-pagination.is-background .el-pager li.active:hover{
    color: #FFF;
  }
  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
    color: #999;
  }
</style>
<style scoped lang="less" type="text/less">
#Blog{
  margin-top: 65px;
  .banner{
    position: relative;
    img{
      width: 100%;
    }
    .bannerText{
      position:absolute;
      top: 40%;
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      .title{
        font-size: 40px;
        font-weight: bold;
        position: relative;
        padding-right: 40px;
        &::before{
          content:'';
          display: inline-block;
          height: 38px;
          width: 3px;
          background: #e2e2e2;
          position: absolute;
          right: 0;
          bottom: 7px;
        }
      }
      .titleSub{
        padding-left: 30px;
        font-size: 20px;
        max-width: 600px;
      }
    }
  }
  .content{
    padding: 60px 0;
    .con{
      width: 60%;
      margin: 0 auto;
      .blogList{
        display: flex;
        justify-content: center;
        align-items: flex-start;
        position: relative;
        margin-bottom: 65px;
        &.active{
          // box-shadow: 0 3px 10px #d6d6d6;
          background: #f8f8f8;
          .Btn{
            color: #333;
            font-weight: bold;
          }
          .right{
            // .detail{
            //   font-size: 17px;
            // }
          }
        }
        &::before{
          content:'';
          display: inline-block;
          height: 1px;
          width: 100%;
          background: #e2e2e2;
          position: absolute;
          bottom: -35px;
        }
        .left{
          width: 30%;
          img{
            // width: 100%;
            max-width: 320px;
            min-height: 180px;
          }

        }
        .right{
          width: 55%;
          margin: 0px 50px 0 70px;
          .title{
            font-size: 20px;
            font-weight: bold;
            color: #333;
            padding-top: 10px;
          }
          .detail{
            font-size: 16px;
            color: #666;
            padding: 20px 0;
            line-height: 28px;
            // max-height: 110px;
            p{
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
              overflow: hidden;
            }
          }
          .time{
            color: #999;
            font-size: 16px;
            position:absolute;
            bottom: 10px;
          }

        }
        .Btn{
          width: 15%;
          align-self: center;
          font-size: 18px;
          color: #999;
          position: relative;
          text-align: right;
          padding-right: 20px;
          .moreBtn{
            display: inline-block;
            cursor: pointer;
          }
          &::before{
            content:'';
            display: inline-block;
            height: 40px;
            width: 1px;
            background: #d6d6d6;
            position: absolute;
            top: -10px;
            right: 90px;
          }
        }
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Blog/Blog.vue